import React from 'react';

const TabBody: React.FC = ({ children }) => {
  return <div className='tab-body'>{children}</div>;
};

export default TabBody;
